import { api } from "../../app/api";
import { BASE_API } from "../../constants/apiUrls";

import {
  GetOverviewResponseType,
  GetTopDealersResponseType,
  GetTransactionsChartResponseType,
} from "../../types/dashboard";

export const dashboardApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getOverview: builder.query<GetOverviewResponseType, object>({
      query: (queryArgs) => ({
        url: BASE_API.getOverview,
        ...queryArgs,
      }),
    }),
    getTopDealers: builder.query<GetTopDealersResponseType, object>({
      query: (queryArgs) => ({
        url: BASE_API.getTopDealers,
        ...queryArgs,
      }),
    }),
    getTransactionsGraph: builder.query<
      GetTransactionsChartResponseType,
      object
    >({
      query: (queryArgs) => ({
        url: BASE_API.getTransactionsGraph,
        ...queryArgs,
      }),
    }),
  }),
});

export const {
  useGetOverviewQuery,
  useGetTopDealersQuery,
  useGetTransactionsGraphQuery,
} = dashboardApi;
